import React from 'react';
import { Link } from 'react-router-dom';
import Container from '../../components/layout/Container/Container';
import Button from '../../components/ui/Button/Button';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Container>
        <div className="not-found-content">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Page Not Found</h2>
          <p className="error-message">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          <Link to="/">
            <Button variant="primary" size="lg">
              Go to Homepage
            </Button>
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;